import angular from 'angular';
import PaginationComponent from './pagination.component';

const pagination = angular
	.module('pagination', [])
	.component('pagination', PaginationComponent)
	.name;

export default pagination;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/pagination/pagination.module.js